import { IUser, IUserQuickStartState, Modify, UUID } from "src/app/core/interfaces";

export namespace User {
  export class Get {
    static readonly type = "[User] Get";
    constructor(public uid: string) {}
  }

  export class GetAll {
    static readonly type = "[User] Get All";
  }

  export class Reset {
    static readonly type = "[User] Reset";
  }

  export class SetQuickStartState {
    static readonly type = "[User] Set Quick Start State";
    constructor(public quickStartState: IUserQuickStartState) {}
  }

  export class UpdateConsentData {
    static readonly type = "[User] Update consent data";
    constructor(
      public consentFirstName: string,
      public consentLastName: string,
      public consentEmail: string
    ) {}
  }

  export class Update {
    static readonly type = "[User] Update";
    constructor(public updatedUser: Modify<IUser, { id: UUID }>) {}
  }
}
